/**
 * Sync store for the active next-intl UI locale.
 * Updated by HtmlLangUpdater during render so auth email callables can read
 * a reliable locale without racing document.documentElement.lang (layout
 * defaults to "en" until the effect runs).
 */
let appLocale: string | null = null

/**
 * Record the current UI locale from next-intl.
 * @param {string} locale Active locale code
 */
export function setAppLocale(locale: string): void {
    const trimmed = (locale || "").trim()
    if (trimmed) {
        appLocale = trimmed
    }
}

/**
 * Best-effort UI locale for Auth email callables.
 * Prefers the sync store (set by HtmlLangUpdater), then document.lang,
 * then navigator.language.
 * @return {string} Locale code
 */
export function getAppLocale(): string {
    if (appLocale) {
        return appLocale
    }
    if (typeof document !== "undefined" && document.documentElement?.lang) {
        const fromDom = document.documentElement.lang.trim()
        if (fromDom) {
            return fromDom
        }
    }
    if (typeof navigator !== "undefined" && navigator.language) {
        return navigator.language
    }
    return "en"
}
